import { initialListPaginationMeta } from "utils/helpers/pagination";

import { TireTypeForm, TireTypeState } from "../types";

export const initialTireTypeForm: TireTypeForm = {
  sort: "",
  description: "",
  code: "",
};

export const initialTireTypeMeta = initialListPaginationMeta;

export const initialState: TireTypeState = {
  loading: false,
  saving: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialTireTypeMeta,
  error: null,
  isAddModalOpen: false,
  form: initialTireTypeForm,
};
